var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "ring-icon-investigation",
  "use": "ring-icon-investigation-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"ring-icon-investigation\"><path d=\"M9.68 11.31h-.5a4.75 4.75 0 0 0 3.58-4.6v-.2L15 2.86 8 0 1 2.86l2.25 3.66a1.37 1.37 0 0 0 0 .19 4.75 4.75 0 0 0 3.58 4.6h-.54A4.08 4.08 0 0 0 2 15.11V16h12v-.87a4.08 4.08 0 0 0-4.32-3.82zM8 3.4a.6.6 0 1 1-.6.6.6.6 0 0 1 .6-.6zm-.9 11.18H3.47a2.89 2.89 0 0 1 2.82-1.87h.81zM4.63 6.71a.28.28 0 0 1 0-.09h6.71v.09a3.37 3.37 0 1 1-6.73 0zm4.27 7.87v-1.87h.78a2.89 2.89 0 0 1 2.82 1.87z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id